import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../../constant/constants.service';
import { Planning } from 'src/app/shared/models/planning';
import { GenericCrudService } from '../../generic-crud.service';

const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		Authorization: 'my-auth-token'
	})
};

@Injectable({
	providedIn: 'root'
})
export class PlanningService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getPlanningByEmployeeId(empId: number): Observable<Planning> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.planningUrl}/${empId}`,
			'getPlanningByEmployeeId'
		);
	}

	getPlanning(): Observable<Planning> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.planningUrl}`,
			'getPlanning'
		);
	}

	getPlanningByYearAndWeekNumberAndEmployeeId(
		year: number,
		weekNumber: number,
		empId: number
	): Observable<Planning> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.planningUrl}/${year}/${weekNumber}/${empId}`,
			'getPlanningByYearAndWeekNumberAndEmployeeId'
		);
	}

	deleteMission(planningId: number, missionId: number, centerId: number) {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.planningUrl}/${planningId}/mission/${missionId}/center/${centerId}`,
			`deleteMission`,
			httpOptions
		);
	}

	getAllInformationToDisplayPlanning(
		centerId: number,
		year: number,
		week: number,
		objRefresh?: {
			withSolution?: boolean;
			withEmployees?: boolean;
			withNotifications?: boolean;
			withVacationTypes?: boolean;
		}
	) {
		let queryParams = new HttpParams();
		queryParams = queryParams.append(
			'withSolution',
			objRefresh.withSolution?.valueOf()
		);
		queryParams = queryParams.append(
			'withEmployees',
			objRefresh.withEmployees?.valueOf()
		);
		queryParams = queryParams.append(
			'withNotifications',
			objRefresh.withNotifications?.valueOf()
		);

		if (
			!objRefresh.withVacationTypes ||
			objRefresh.withVacationTypes === undefined
		) {
			objRefresh.withVacationTypes = false;
		}
		queryParams = queryParams.append(
			'withVacationTypes',
			objRefresh.withVacationTypes?.valueOf()
		);

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.planningUrl}/${centerId}/${year}/${week}/display`,
			`getAllInformationToDisplayPlanning`,
			httpOptions
		);
	}
}
